/**
 * Type of Notifications that are preexisitng
 *
 * @export
 * @enum {number}
 */
export var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["Success"] = 0] = "Success";
    NotificationType[NotificationType["Info"] = 1] = "Info";
    NotificationType[NotificationType["Warning"] = 2] = "Warning";
    NotificationType[NotificationType["Error"] = 3] = "Error";
})(NotificationType || (NotificationType = {}));
/**
 * Snackbar types
 *
 * @export
 * @enum {number}
 */
export var SnackbarType;
(function (SnackbarType) {
    SnackbarType[SnackbarType["DEFAULT"] = 0] = "DEFAULT";
    SnackbarType[SnackbarType["CUSTOM"] = 1] = "CUSTOM";
})(SnackbarType || (SnackbarType = {}));
//# sourceMappingURL=snackbar.js.map